/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Login_SuccessInputs */

const cs_portal_login_success = /** @type {(inputs: Portal_Login_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení úspěšné.`)
};

const en_portal_login_success = /** @type {(inputs: Portal_Login_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed in.`)
};

/**
* | output |
* | --- |
* | "Signed in." |
*
* @param {Portal_Login_SuccessInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_login_success = /** @type {((inputs?: Portal_Login_SuccessInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Login_SuccessInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_login_success(inputs)
	return cs_portal_login_success(inputs)
});